import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

import { isAgent } from './pageHelpers';

export const hasClient = (answers: AnswerSet, channel: string) => {
  return (
    isAgent(answers, channel) &&
    answers['agent.relation_to_seller'] !== 'self' &&
    answers['seller.relation_to_owner'] !== 'AgentAndOwner'
  );
};

export const your = (answers: AnswerSet, channel: string) => {
  if (hasClient(answers, channel)) {
    return "your client's";
  }
  return 'your';
};

export const you = (answers: AnswerSet, channel: string) => {
  if (hasClient(answers, channel)) {
    return 'your client';
  }
  return 'you';
};

export const titleWord = (str: string) => {
  return `${str[0].toUpperCase()}${str.substring(1)}`;
};

export const youAre = (answers: AnswerSet, channel: string) => {
  return hasClient(answers, channel) ? 'your client is' : "you're";
};

export const areYou = (answers: AnswerSet, channel: string) => {
  return hasClient(answers, channel) ? 'is your client' : 'are you';
};

export const home = () => {
  return 'home';
};

export const yourHome = (answers: AnswerSet, channel: string) => {
  return `${your(answers, channel)} ${home()}`;
};
